import { render, staticRenderFns } from "./TableTypeCustomFieldDate.vue?vue&type=template&id=19c42da4"
import script from "./TableTypeCustomFieldDate.vue?vue&type=script&lang=js"
export * from "./TableTypeCustomFieldDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports